module.exports = __webpack_public_path__ + "static/img/coope.872231f5.png";